/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ConnectDevelopers/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import CreateToken from './CreateToken/index'
import CreateTokenAction from './CreateTokenAction/index'
import EnsureUrl from 'DesignSystem/EnsureUrl/react'
import Keys from './Keys/index'
import React from 'react'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import TysiaHorizDivider from 'DesignSystem/TysiaHorizDivider/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import TysiaTextLink from 'DesignSystem/TysiaTextLink/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function ConnectDevelopers({
  children,
  viewPath = "/App/Account/Content/Settings/Content/ConnectDevelopers"
  
}) {
let dtSpaceL = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.l'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<EnsureUrl
  viewPath={`${viewPath}/EnsureUrl`}
/>
<div
  data-testid="ConnectDevelopers.Vertical"
  data-view-path={viewPath}
 style={{'--pt-1-1gnPY': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="ConnectDevelopers.Vertical:1"
  data-view-path={viewPath}
 style={{'--pl-2-1gnPY': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL,'--pr-3-1gnPY': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL}}
 className={`views-block ${styles.Vertical1}`}
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h2"
 text="Developers"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="medium"
 marginTop={dtSpaceXs}
 color={dtColorsNeutral500}
 text="Manage your personal access tokens."
/>
<TysiaTextLink
  viewPath={`${viewPath}/TysiaTextLink`}
 text="Learn more about the Greyfinch Connect and its API."
 goTo="https://connect.greyfinch.com"
/>
</div>
<div
  data-testid="ConnectDevelopers.Vertical:2"
  data-view-path={viewPath}
 style={{'--mt-4-1gnPY': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM}}
 className={`views-block ${styles.Vertical2}`}
>
<TysiaHorizDivider
  viewPath={`${viewPath}/TysiaHorizDivider`}
 theme="light"
/>
<div
  data-testid="ConnectDevelopers.Vertical:3"
  data-view-path={viewPath}
 style={{'--pl-2-1gnPY': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL,'--pr-3-1gnPY': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL,'--pt-1-1gnPY': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical3}`}
>
<CreateTokenAction
  viewPath={`${viewPath}/CreateTokenAction`}
/>
<CreateToken
  viewPath={`${viewPath}/CreateToken`}
/>
<Keys
  viewPath={`${viewPath}/Keys`}
/>
</div>
</div>
</div>
{children}
</React.Fragment>)
}